import axios from 'axios';
const API_URL = '/api';

const api = axios.create({
  //baseURL: API_URL,
  baseURL: '/api',  // Відносний шлях, Apache проксує
  headers: {
    'Content-Type': 'application/json'
  }
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
export default api;
